exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max_width{max-width:50%!important}@media only screen and (max-width:767px){.max_width{max-width:100%!important}}", ""]);

// exports
